import React from 'react';
import { motion } from 'framer-motion';
import { AnimatedCounter } from './shared/AnimatedCounter';
const stats = [{
  value: 500,
  suffix: '+',
  label: 'Zadovoljnih porodica'
}, {
  value: 1000,
  suffix: '+',
  label: 'Uspješnih angažmana'
}, {
  value: 24,
  suffix: '/7',
  label: 'Podrška'
}, {
  value: 100,
  suffix: '%',
  label: 'Profesionalna usluga'
}];
export function Stats() {
  return <section className="relative w-full bg-ink py-16 lg:py-20" data-id="element-256">
      <div className="mx-auto max-w-7xl px-5 sm:px-8" data-id="element-257">
        <div className="grid grid-cols-2 gap-8 lg:grid-cols-4" data-id="element-258">
          {stats.map((s, i) => <motion.div key={s.label} initial={{
          opacity: 0,
          y: 24
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: i * 0.1
        }} className="text-center" data-id="element-259">
              <div className="font-display text-4xl font-bold text-gold sm:text-5xl lg:text-6xl" data-id="element-260">
                <AnimatedCounter value={s.value} suffix={s.suffix} data-id="element-261" />
              </div>
              <div className="mt-3 text-sm font-medium uppercase tracking-wide text-white/70 sm:text-base" data-id="element-262">
                {s.label}
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}